import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports
import type { PayloadAction } from "@reduxjs/toolkit";

import type { SubmitConsentAuthorizationFormPayload } from "./ConsentAuthorization.types";

const initialState = {
  loading: true,
  canResendOtp: false,
  resendingOtp: false
};

const consentAuthorizationSlice = createSlice({
  name: "consentAuthorization",
  initialState,
  reducers: {
    toggleLoadingStatus(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    toggleCanResendOtp: {
      reducer: (state, action: PayloadAction<{ canResendOtp: boolean; resendingOtp: boolean }>) => {
        state.canResendOtp = action.payload.canResendOtp;
        state.resendingOtp = action.payload.resendingOtp;
      },
      prepare: (canResendOtp: boolean, resendingOtp: boolean) => {
        return {
          payload: {
            canResendOtp,
            resendingOtp
          }
        };
      }
    },
    resendOtp(state) {
      state.resendingOtp = true;
    },
    submitConsentAuthorizationForm(state, action: PayloadAction<SubmitConsentAuthorizationFormPayload>) {
      return state;
    },
    destroy() {
      return initialState;
    }
  }
});

export default consentAuthorizationSlice.reducer;
export const {
  toggleCanResendOtp,
  resendOtp,
  submitConsentAuthorizationForm,
  destroy
} = consentAuthorizationSlice.actions;
export const consentAuthorizationActions = consentAuthorizationSlice.actions;
